import devLocal from './configs/devLocal'
import dev from './configs/dev'
import devOnline from './configs/devOnline'
import prodHuadong1 from './configs/prodHuadong1'
import prodHuadong2 from './configs/prodHuadong2'
import prodKml from './configs/prodKml'


const getConfig = (configKey) => {
  let configMap = {
    devLocal: devLocal,
    dev: dev,
    devOnline: devOnline,
    prodHuadong1: prodHuadong1,
    prodHuadong2: prodHuadong2,
    prodKml: prodKml,
  }
  return configMap[configKey] || {}
}


const config = getConfig(process.env.VUE_APP_ENV_STR);
export default config